import Api from './BaseRequest'

const GetMethods = (accountOrderHistoryId, payInvoiceableLines) => {
    if (accountOrderHistoryId) {
        return Api.Get('/api/payment_methods?accountOrderHistoryId=' + accountOrderHistoryId);
    }
    if (payInvoiceableLines) {
        return Api.Get('/api/payment_methods?invoiceableLines=1');
    }
    return Api.Get('/api/payment_methods');
};

const PostVipps = (data) => {
    return Api.Post('/api/vipps', data)
};

const PostSwish = (data) => {
    return Api.Post('/api/swish', data)
};

const PostCard = (data) => {
    return Api.Post('/api/card', data)
};

const GetVippsTransactionStatus = (data) => {
    return Api.Get('/api/vipps/status', data)
};

const GetVippsNoSessionTransaction = (hash, forceStatus) => {
    if (forceStatus) {
        return Api.Get('/v_request/' + hash + '?fs=1')
    }
    return Api.Get('/v_request/' + hash)
};

const GetVippsNoSessionTransactionStatus = (hash, data) => {
    return Api.Get('/v_response/' + hash, data)
};

const GetPaymentNoSessionTransaction = (hash, forceStatus) => {
    if (forceStatus) {
        return Api.Get('/p_request/' + hash + '?fs=1')
    }
    return Api.Get('/p_request/' + hash)
};

const GetTransactionStatus = (data) => {
    return Api.Get('/api/payment/status', data)
};

const GetInvoicesAndNotInvoicedLines = () => {
    return Api.Get('/api/payment/invoices')
}

const PaymentInProgress = (paymentId) => {
    return Api.Post('/api/payment/inprogress/' + paymentId)
}

export default {
    GetMethods,
    PostVipps,
    PostSwish,
    PostCard,
    GetVippsTransactionStatus,
    GetVippsNoSessionTransaction,
    GetVippsNoSessionTransactionStatus,
    GetPaymentNoSessionTransaction,
    GetTransactionStatus,
    GetInvoicesAndNotInvoicedLines,
    PaymentInProgress,
}
